import { render, staticRenderFns } from "./ChildSDKList.vue?vue&type=template&id=b9f4448e&scoped=true"
import script from "./ChildSDKList.vue?vue&type=script&lang=js"
export * from "./ChildSDKList.vue?vue&type=script&lang=js"
import style0 from "./ChildSDKList.vue?vue&type=style&index=0&id=b9f4448e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9f4448e",
  null
  
)

export default component.exports